<template>
    <div style="height:100%;border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
        <div class="row">
            <div class="col-12 text-left">
                <h4 class="card-title pb-2 mb-0">Total Device User iOffice Plus</h4>
            </div>
        </div>
        <div class="row no-gutters">
            <div class="col-md-1">
                <hr class="border-primary"/>
            </div>
            <div class="col-md-11">
                <hr/>
            </div>
        </div>
        <div id="chart">
            <apexchart type="donut" height="300" v-if="status == true" :options="chartOptions" :series="series"></apexchart>
        </div>
        <div class="row no-gutters mt-3">
            <div class="col-6 text-left">
                <CButton color="success" @click="downloads()" class="w-25" variant="outline">Export Excel</CButton>
            </div>
            <div class="col-6 text-right">
                <CButton color="primary" @click="openModal('Android')" class="w-25 mr-1" variant="outline">Android</CButton>
                <CButton color="success" @click="openModal('IOS')" class="w-25" variant="outline">IOS</CButton>
            </div>
        </div>
        <CModal
            size="xl"
            :centered="true"
            color="white"
            :show.sync="detailModal"
            :closeOnBackdrop="false"
        >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Detail Device {{jenisDevice}}</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="detailModal = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow class="mb-3">
                        <CCol sm="12">
                            <div id="chart">
                                <apexchart type="donut" height="330" v-if="statusDetail == true" :options="chartOptionsDetail" :series="seriesDetail"></apexchart>
                            </div>
                        </CCol>
                    </CRow>
                    <CRow class="mb-3 mt-2">
                        <CCol sm="12">
                            <CButton @click="detailModal = false" color="primary" variant="outline" style="float:right" class="btn mr-2">Kembali</CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</template>

<script>
import {DataApi} from "../../service/DataApi";

const xlsx = require('json-as-xlsx')
export default {
    props: ['hitDevice', 'deviceAndroid', 'deviceIos'],
    
    data() {
        return {
            closeIcon: require('../../assets/menu/icon_close.svg'),
            status: false,
            statusDetail: false,
            series: [],
            seriesDetail: [],
            chartOptions: {
                chart: {
                    id: 'diagram',
                    width: 300,
                    type: 'donut',
                    dropShadow: {
                        enabled: true,
                        color: '#111',
                        top: -1,
                        left: 3,
                        blur: 3,
                        opacity: 0.2
                    }
                },
                stroke: {
                    width: 0,
                },
                plotOptions: {
                pie: {
                    donut: {
                    labels: {
                        show: true,
                        total: {
                            showAlways: true,
                            show: true,
                            formatter: function (w) {
                                let vals = w.globals.seriesTotals
                                var i = 0
                                let totals = 0
                                for(i=0;i<vals.length;i++) {
                                    totals += vals[i]
                                }
                                let val = totals.toString()
                                let leng = val.length
                                let sisa 	= leng % 3
                                let rupiah 	= val.substr(0, sisa)
                                let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                                    
                                if (ribuan) {
                                    let separator = sisa ? '.' : ''
                                    rupiah += separator + ribuan.join('.')
                                }
                                return rupiah
                            }
                        },
                        name: {
                            show: true,
                            formatter: function (val) {
                                return val
                            }
                        },
                        value: {
                            show: true,
                            formatter: function (val) {
                                let value = val.toString()
                                let leng = value.length
                                let sisa 	= leng % 3
                                let rupiah 	= value.substr(0, sisa)
                                let ribuan 	= value.substr(sisa).match(/\d{3}/g)
                                    
                                if (ribuan) {
                                    let separator = sisa ? '.' : ''
                                    rupiah += separator + ribuan.join('.')
                                }
                                return rupiah
                            }
                        },
                    }
                    }
                }
                },
                labels: ['Android', 'IOS'],
                dataLabels: {
                    dropShadow: {
                        blur: 3,
                        opacity: 0.8
                    }
                },
                states: {
                    hover: {
                        filter: 'none'
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
            chartOptionsDetail: {
                chart: {
                    id: 'diagram',
                    width: 300,
                    type: 'donut',
                    dropShadow: {
                        enabled: true,
                        color: '#111',
                        top: -1,
                        left: 3,
                        blur: 3,
                        opacity: 0.2
                    }
                },
                stroke: {
                    width: 0,
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                total: {
                                    showAlways: true,
                                    show: true,
                                    formatter: function (w) {
                                        let vals = w.globals.seriesTotals
                                        var i = 0
                                        let totals = 0
                                        for(i=0;i<vals.length;i++) {
                                            totals += vals[i]
                                        }
                                        let val = totals.toString()
                                        let leng = val.length
                                        let sisa 	= leng % 3
                                        let rupiah 	= val.substr(0, sisa)
                                        let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                                            
                                        if (ribuan) {
                                            let separator = sisa ? '.' : ''
                                            rupiah += separator + ribuan.join('.')
                                        }
                                        return rupiah
                                    }
                                },
                                name: {
                                    show: true,
                                    formatter: function (val) {
                                        return val
                                    }
                                },
                                value: {
                                    show: true,
                                    formatter: function (val) {
                                        let value = val.toString()
                                        let leng = value.length
                                        let sisa 	= leng % 3
                                        let rupiah 	= value.substr(0, sisa)
                                        let ribuan 	= value.substr(sisa).match(/\d{3}/g)
                                            
                                        if (ribuan) {
                                            let separator = sisa ? '.' : ''
                                            rupiah += separator + ribuan.join('.')
                                        }
                                        return rupiah
                                    }
                                },
                            }
                        }
                    }
                },
                labels: [],
                dataLabels: {
                    dropShadow: {
                        blur: 3,
                        opacity: 0.8
                    }
                },
                states: {
                    hover: {
                        filter: 'none'
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
            detailModal: false
        }
    },
    watch: {
        hitDevice(baru, lama) {
            this.status = false
            let android = parseInt(this.deviceAndroid)
            let ios = parseInt(this.deviceIos)
            if(android < 0) {
                android = 0
            }
            if(ios < 0) {
                ios = 0
            }
            this.series[0] = android
            this.series[1] = ios
            this.status = true
        },
        detailModal() {
            if(this.detailModal == false) {
                this.jenisDevice = ''
            }
        }
    },
    methods: {
        openModal(val) {
            let os = ''
            if(val == 'Android') {
                os = 'ANDROID'
            } else {
                os = 'IOS'
            }
            let payload = {
                os: os,
                tipe: this.hitDevice
            }
            this.jenisDevice = val

            DataApi.post("dashboard/superadmin/device", payload)
            .then( response => {
                this.seriesDetail = []
                this.chartOptionsDetail = {
                    labels: []
                }
                this.statusDetail = false
                let res = response.data
                if(res.success == true) {
                    let dev = res.data.data
                    let labels = []
                    var i = 0
                    for(i=0;i<dev.length;i++) {
                        let devices = parseInt(dev[i].jumlah)
                        let names = dev[i].tipe + ' V.' + dev[i].version
                        if(devices < 0) {
                            devices = 0
                        }
                        this.seriesDetail[i] = devices
                        labels[i] = names
                    }
                    this.chartOptionsDetail = {
                        labels: labels,
                        plotOptions: {
                            pie: {
                                donut: {
                                    labels: {
                                        show: true,
                                        total: {
                                            showAlways: true,
                                            show: true,
                                            formatter: function (w) {
                                                let vals = w.globals.seriesTotals
                                                var i = 0
                                                let totals = 0
                                                for(i=0;i<vals.length;i++) {
                                                    totals += vals[i]
                                                }
                                                let val = totals.toString()
                                                let leng = val.length
                                                let sisa 	= leng % 3
                                                let rupiah 	= val.substr(0, sisa)
                                                let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                                                    
                                                if (ribuan) {
                                                    let separator = sisa ? '.' : ''
                                                    rupiah += separator + ribuan.join('.')
                                                }
                                                return rupiah
                                            }
                                        },
                                        name: {
                                            show: true,
                                            formatter: function (val) {
                                                return val
                                            }
                                        },
                                        value: {
                                            show: true,
                                            formatter: function (val) {
                                                let value = val.toString()
                                                let leng = value.length
                                                let sisa 	= leng % 3
                                                let rupiah 	= value.substr(0, sisa)
                                                let ribuan 	= value.substr(sisa).match(/\d{3}/g)
                                                    
                                                if (ribuan) {
                                                    let separator = sisa ? '.' : ''
                                                    rupiah += separator + ribuan.join('.')
                                                }
                                                return rupiah
                                            }
                                        },
                                    }
                                }
                            }
                        }
                    }
                }
                this.statusDetail = true
                this.detailModal = true
            })
        },
        downloads() {
            this.$store.state.loadingScreen = true
            let payload = {
                os: '',
                tipe: this.hitDevice
            }
            DataApi.post("dashboard/superadmin/device", payload)
            .then( response => {
                let res = response.data
                if(res.success == true) {
                    let temp = response.data.data.data
                    var i = 0
                    let androids = []
                    let ioss = []
                    for(i=0;i<temp.length;i++) {
                        let names = temp[i].os
                        if(names == 'ANDROID') {
                            androids.push(temp[i])
                        } else if(names == 'IOS') {
                            ioss.push(temp[i])
                        }
                    }
                    let fileName = 'Data Devive'
                    let data = [
                        {
                            sheet: 'ANDROID',
                            columns: [
                                { label: 'Nama OS', value: 'os'  },
                                { label: 'Version', value: 'version'  },
                                { label: 'Tipe', value: 'tipe'  },
                                { label: 'Jumlah', value: 'jumlah'  },
                                { label: 'Persentase', value: 'persentase'  },
                            ],
                            content: androids
                        },
                        {
                            sheet: 'IOS',
                            columns: [
                                { label: 'Nama OS', value: 'os'  },
                                { label: 'Version', value: 'version'  },
                                { label: 'Tipe', value: 'tipe'  },
                                { label: 'Jumlah', value: 'jumlah'  },
                                { label: 'Persentase', value: 'persentase'  },
                            ],
                            content: ioss
                        }
                    ]            
                    let settings = {
                        fileName: fileName
                    }
                    xlsx(data, settings)
                }
                this.$store.state.loadingScreen = false
            })
        }
    },
    mounted() {
    },
}
</script>
<style scoped>
.card-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
    height: 100%;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
</style>